import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { unicodeToString } from "../../../../Js/Common";

const pathToParentMenu = ["root"];

const WwSmallChit1 = (props) => {
  const [classnames, setClassnames] = useState("");

  useEffect(() => {
    // if (props.data && props.data.class) {
    //   setClassnames(props.data.class);
    // }
  }, [props.data]);

  return (
    <>
      {props.data && props.data.source && (
        <Grid container>
          <Grid item xs={12}>
            <Box
              sx={{
                p: 0.6,
                pl: 0,
                my: 1,
                mt: 0.5,
                mr: 1,
                border: "1px solid #CCCCCC",
                borderRadius: 2,
                '@media (min-width: 1636px)': {padding: 1}
              }}
            >
              <Typography variant="body2" sx={{letterSpacing: '1px',wordSpacing: '2px', color: "primary.main", pl: 1, fontSize: '120% !important', fontWeight: '500','@media (min-width: 1636px)':{fontSize: '140% !important',} }}>
                <div
                  className={classnames}
                  id={props.data.myId.self}
                  dangerouslySetInnerHTML={{
                    __html: unicodeToString(props.data.source),
                  }}
                  style={{
                    display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'
                  }}
                ></div>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default WwSmallChit1;
